<template>
  <div class="title">
    <h1 v-if="main" >
      <span class="title__text" v-html="title"></span><span class="line"></span>
    </h1>
    <h2 v-else class="astitle">
      <span class="title__text" v-html="title"></span><span class="line"></span>
    </h2>
  </div>
</template>

<script>
import { TweenMax, Power0, Power2 } from "gsap"
import TimelineMax from "gsap/TimelineMax"
import 'intersection-observer'

export default {
  name: 'Banner',
  props: {
    title: String,
    main: Boolean
  },
  data() {
    return {
      timelines: []
    }
  },
  methods: {
    TimeLineFactory(conf) {
      conf = conf || {}
      let t = new TimelineMax(conf)
      this.timelines.push(t)
      return t
    }
  },
   beforeDestroy() {
    for(let t of this.timelines) {
      t.kill()
    }
    TweenMax.killChildTweensOf(this.$el)
  },
  mounted() {
    require("@/js/vendor/SplitText.js")

    this.$nextTick(() => {
      let options = {
        rootMargin: '0px',
        threshold: 0.6
      };
      const tl = this.TimeLineFactory({
        paused: true
      })
      let title = new SplitText(this.$el.querySelector('.title__text'), {type: 'chars'})
      let line = this.$el.querySelector('.line')
      tl.addLabel('start')
      tl.from(line, 1, {xPercent: '-100', ease: Power1.easeOut})
      tl.staggerFrom(title.chars, 0.6, {yPercent: '100', autoAlpha:0, ease: Power2.easeOut}, 0.02, 'start')

      let obs = new IntersectionObserver(function (entries, observer) {
        entries.forEach(function (entry) {
          if (entry.intersectionRatio > 0) {
            tl.play();
            obs.unobserve(entry.target);
          }
        });
      }, options);
      obs.observe(this.$el)
    })
  }
}
</script>

<style scoped lang="scss">
.astitle,
h1 {
  overflow: hidden;
  position: relative;
  display: inline-block;
  font-size: 38px;
  font-weight: 200;
  margin-bottom: 30px;
  padding-bottom: 0.1em;
  @include media-breakpoint-up(lg) {
    font-size: 80px;
    margin-bottom: 50px;
  }
}
.line {
  position: absolute;
  left: 0;
  top: calc(100% - 2px);
  height: 2px;
  border-bottom: 1px solid $red;
  width: 100%;
}
</style>

